import { render } from "./ColorfulBigBar.vue?vue&type=template&id=27c5ced8"
import script from "./ColorfulBigBar.vue?vue&type=script&lang=js"
export * from "./ColorfulBigBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__